export const calculateVatFreePrice = (priceWithVat: number, vat: number): number => {
  return parseInt((priceWithVat / (vat / 100 + 1)).toString(), 10)
}
